export default "__VITE_ASSET__Es5$pk7a__"